import React from 'react';
import { localeStrings as strings } from 'applicationConfig';

const s = strings.migrationBanner;

const MigrationBanner = () => (
  <div className="migration-banner">
    <p className="migration-banner__primary">
      <strong>{s.primary}</strong>
    </p>
    <p className="migration-banner__secondary">
      {s.secondary}
    </p>
    <div className="migration-banner__links-wrapper">
      <ul className="migration-banner__links">
        <li>
          {s.postTradeLabel}{' '}
          <a href={s.postTradeUrl} target="_blank" rel="noopener noreferrer">
            {s.postTradeUrl}
          </a>
        </li>
        <li>
          {s.preTradeLabel}{' '}
          <a href={s.preTradeUrl} target="_blank" rel="noopener noreferrer">
            {s.preTradeUrl}
          </a>
        </li>
      </ul>
    </div>
  </div>
);

export default MigrationBanner;



// WEBPACK FOOTER //
// ./src/containers/Login/MigrationBanner.jsx